import { tgxApi } from "../../../app/tgxApi";
import {
    getAuthorizationHeader,
    getFileDownloadHeaders,
    handleQueryError,
    handleQueryErrorAndSuccess
} from "../../../helpers/utils/RtkQueryUtils";
import { getFileName, serialize } from "../../../helpers/utils/Utils";
import { downloadFile } from "../../../helpers/utils/FileUtils";

export const collectorLinkApi = tgxApi.injectEndpoints({
    endpoints: (build) => ({
        searchCollectorLinks: build.query({
            query: (data) => {
                // Serialize the data to query parameters
                let paramData = serialize(data);
                return {
                    url: `/ajax/collector-links?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['collectorLinks'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),

        createCollectorLink: build.mutation({
            query: (requestBody) => {
                return {
                    url: `/ajax/create/collector-link`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['collectorLinks'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Created", "Collector Links")
            },
        }),
        getCollectorLinkById: build.query({
            query: (id) => {
                return {
                    url: `/ajax/get-collector-link-by-id/${id}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['collectorLinkById'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        updateCollectorLink: build.mutation({
            query: ({ id, requestBody }) => {
                return {
                    url: `/ajax/update/collector-link/${id}`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['collectorLinks', 'collectorLinkById', 'userAuditableInfo'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Collector Link")
            },
        }),

        deleteCollectorLink: build.mutation({
            query: (id) => {
                return {
                    url: `/ajax/delete-collector-link-by-id/${id}`,
                    method: 'DELETE',
                    headers: getAuthorizationHeader(),
                };
            },
            invalidatesTags: ['collectorLinks', 'collectorLinkById', 'userAuditableInfo'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Deleted", "Collector Link")
            },
        }),

        exportCollectorLinkData: build.query({
            query: (query) => {
                return {
                    url: `/export/collector-link`,
                    method: 'POST',
                    params: query,
                    headers: getFileDownloadHeaders(),
                    responseType: 'arraybuffer',
                    responseHandler: async (response: { blob: () => any; }) => {
                        const blob = await response.blob();
                        downloadFile(blob, getFileName("collectorLink"))
                        return { success: true };
                    },
                };
            },
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),

    }),
});


export const {
    useCreateCollectorLinkMutation,
    useGetCollectorLinkByIdQuery,
    useUpdateCollectorLinkMutation,
    useSearchCollectorLinksQuery,
    useLazyExportCollectorLinkDataQuery,
    useDeleteCollectorLinkMutation
} = collectorLinkApi;